import { render } from "./indexnewVipRecharge-old.vue?vue&type=template&id=17d86f88&scoped=true&ts=true"
import script from "./indexnewVipRecharge-old.vue?vue&type=script&lang=ts"
export * from "./indexnewVipRecharge-old.vue?vue&type=script&lang=ts"

import "./indexnewVipRecharge-old.vue?vue&type=style&index=0&id=17d86f88&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d86f88"]])

export default __exports__